var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcodeimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.765015,
    y: 0.470108,
    width: 141.197,
    height: 141.197,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7087 20.2376V57.2055H27.4641V66.4474H37.2195V57.2055H56.7303V20.2376H17.7087ZM56.7303 57.2055V66.4474H66.4857V75.6894H46.9749V84.9313H17.7087V121.899H56.7303V84.9313H85.9965V75.6894H76.2411V66.4474H95.7519V57.2055H105.507V66.4474H115.263V57.2055H125.018V20.2376H85.9965V57.2055H56.7303ZM115.263 66.4474V75.6894H125.018V66.4474H115.263ZM115.263 75.6894H105.507V84.9313H115.263V75.6894ZM115.263 84.9313V94.1733H125.018V84.9313H115.263ZM115.263 94.1733H105.507V84.9313H95.7519V94.1733H71.3634V121.899H81.1188V103.415H100.63V112.657H110.385V103.415H115.263V94.1733ZM100.63 112.657H90.8742V121.899H100.63V112.657ZM105.507 75.6894V66.4474H95.7519V75.6894H105.507ZM46.9749 75.6894V66.4474H37.2195V75.6894H46.9749ZM27.4641 66.4474H17.7087V75.6894H27.4641V66.4474ZM66.4857 20.2376V38.7215H61.608V47.9635H66.4857V52.5845H76.2411V38.7215H81.1188V29.4796H76.2411V20.2376H66.4857ZM27.4641 29.4796H46.9749V47.9635H27.4641V29.4796ZM95.7519 29.4796H115.263V47.9635H95.7519V29.4796ZM32.3418 34.1006V43.3425H42.0972V34.1006H32.3418ZM100.63 34.1006V43.3425H110.385V34.1006H100.63ZM27.4641 94.1733H46.9749V112.657H27.4641V94.1733ZM32.3418 98.7943V108.036H42.0972V98.7943H32.3418ZM115.263 112.657V121.899H125.018V112.657H115.263Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeimage);
export default __webpack_public_path__ + "static/media/barcode image.bf6bc28d962b33ead00a65b73dc7a565.svg";
export { ForwardRef as ReactComponent };